import { CircularProgress } from '@mui/material';
import React, { PropsWithChildren, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { socket } from '../api/sockets';
import { connectedSet, variablesSnapshot, variablesSet } from './actions';
import { useSelector } from './utils';
import { Variables } from './types';

type Props = PropsWithChildren<{
  //
}>;

export const VariablesProvider = ({ children }: Props) => {
  const dispatch = useDispatch();

  const isReady = useSelector(({ variables }) =>
    Boolean(Object.keys(variables).length)
  );

  useEffect(() => {
    const connect = () => dispatch(connectedSet(true));
    const disconnect = () => dispatch(connectedSet(false));

    const onStoreSnapshot = ({ store }: { store: Variables }) =>
      dispatch(variablesSnapshot(store));
    const onStoreChange = ({ payload }: { payload: Partial<Variables> }) => {
      dispatch(variablesSet(payload));
    };

    socket.on('connect', connect);
    socket.on('disconnect', disconnect);

    socket.on('store:snapshot', onStoreSnapshot);
    socket.on('store:change', onStoreChange);

    return () => {
      socket.off('connect', connect);
      socket.on('disconnect', disconnect);

      socket.off('store:snapshot', onStoreSnapshot);
      socket.off('store:change', onStoreChange);
    };
  }, []);

  return (
    <>
      {isReady ? (
        children
      ) : (
        <CircularProgress sx={{ display: 'block', mx: 'auto', mt: 4 }} />
      )}
    </>
  );
};
